import React from "react";
export default function OrderedImageCountProvider(props) {
    return React.createElement("div", { className: "" }, "(Sztuk zdj\u0119cia)");
}
